import { useTranslation } from 'react-i18next';
// frontend/src/hooks/useTimezone.js - Hook para manejar zonas horarias
import { useState, useEffect } from 'react';
import { timezoneHelpers } from '../services/api';

export const useTimezone = () => {
  const { t } = useTranslation();
    const [timezones, setTimezones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [groupedTimezones, setGroupedTimezones] = useState(null);

    // Cargar zonas horarias al montar el componente
    useEffect(() => {
        loadTimezones();
    }, []);

    const loadTimezones = async () => {
        try {
            setLoading(true);
            setError(null);

            const timezonesData = await timezoneHelpers.loadTimezones();
            setTimezones(timezonesData);

        } catch (err) {
            console.error(t('hardcoded.components_common_timezoneselect.error_loading_timezones'), err);
            setError(t('hardcoded.hooks_usetimezone.error_al_cargar_las_zonas'));

            // Usar fallback en caso de error
            const fallbackTimezones = timezoneHelpers.getFallbackTimezones();
            setTimezones(fallbackTimezones);

        } finally {
            setLoading(false);
        }
    };

    const loadGroupedTimezones = async () => {
        try {
            const grouped = await timezoneHelpers.getTimezonesGroupedByRegion();
            setGroupedTimezones(grouped);
            return grouped;
        } catch (err) {
            console.error('Error loading grouped timezones:', err);
            return null;
        }
    };

    const findTimezone = async (value) => {
        try {
            return await timezoneHelpers.findTimezoneByValue(value);
        } catch (err) {
            console.error('Error finding timezone:', err);
            return null;
        }
    };

    const getCurrentTimezone = () => {
        return timezoneHelpers.getUserTimezone();
    };

    const validateTimezone = (timezone) => {
        return timezoneHelpers.isValidTimezone(timezone);
    };

    const formatInTimezone = (date, timezone, options = {}) => {
        return timezoneHelpers.formatInTimezone(date, timezone, options);
    };

    const getTimezoneOffset = (timezone) => {
        return timezoneHelpers.getTimezoneOffset(timezone);
    };

    // Filtrar zonas horarias por texto de búsqueda
    const filterTimezones = (searchText) => {
        if (!searchText) return timezones;

        const search = searchText.toLowerCase();
        return timezones.filter(tz =>
            tz.label.toLowerCase().includes(search) ||
            tz.value.toLowerCase().includes(search) ||
            tz.abbr.toLowerCase().includes(search)
        );
    };

    // Obtener zonas horarias más comunes (basado en offset popular)
    const getPopularTimezones = () => {
        const popularOffsets = [-8, -7, -6, -5, -4, -3, 0, 1, 2, 8, 9];

        return timezones.filter(tz =>
            popularOffsets.includes(tz.offset)
        ).slice(0, 15); // Limitar a 15 más populares
    };

    return {
        // Estado
        timezones,
        loading,
        error,
        groupedTimezones,

        // Funciones
        loadTimezones,
        loadGroupedTimezones,
        findTimezone,
        getCurrentTimezone,
        validateTimezone,
        formatInTimezone,
        getTimezoneOffset,
        filterTimezones,
        getPopularTimezones,

        // Utilidades
        refresh: loadTimezones
    };
};